import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Trash2, CheckCircle2, XCircle } from "lucide-react";
import { SaleLines, decideRequest } from "@/components/DeleteRequests";
import { fmtNum } from "@/lib/helpers";

function AlertShell({ tone, icon: Icon, title, sub, testId, children }) {
  return (
    <Dialog open onOpenChange={() => {}}>
      <DialogContent overlayClassName="z-[100]" className={`z-[100] bg-slate-900 border-2 ${tone[0]} max-w-md [&>button]:hidden`} onInteractOutside={(e) => e.preventDefault()}
                     onEscapeKeyDown={(e) => e.preventDefault()} data-testid={testId}>
        <DialogHeader>
          <div className={`mx-auto h-16 w-16 rounded-2xl border flex items-center justify-center mb-2 ${tone[1]}`}><Icon size={30} /></div>
          <DialogTitle className={`text-center font-display text-2xl ${tone[2]}`}>{title}</DialogTitle>
          {sub && <p className="text-center text-sm text-slate-400">{sub}</p>}
        </DialogHeader>
        {children}
      </DialogContent>
    </Dialog>
  );
}

export function DeleteRequestAlert({ m, rest, ack }) {
  const act = async (a) => { if (await decideRequest(m.request_id, a)) ack(); };
  return (
    <AlertShell tone={["border-amber-500/60", "bg-amber-500/15 border-amber-500/40 text-amber-400", "text-amber-300"]} icon={Trash2}
                title="Silme Onayı Bekleniyor" sub={`${m.requested_by} · ${m.count} satış · ${fmtNum(m.qty)} adet`} testId="delete-request-alert">
      <SaleLines sales={m.sales} />
      {rest > 0 && <p className="text-center text-xs text-slate-500">{rest} bildirim daha var</p>}
      <div className="grid grid-cols-2 gap-2">
        <Button variant="outline" className="py-5 border-slate-700" onClick={() => act("reject")} data-testid="delete-request-alert-reject">Reddet</Button>
        <Button className="py-5 bg-red-600 hover:bg-red-500 text-white" onClick={() => act("approve")} data-testid="delete-request-alert-approve">Onayla ve Sil</Button>
      </div>
      <div className="text-center"><button onClick={ack} className="text-xs text-slate-500 hover:text-slate-300" data-testid="delete-request-alert-later">Sonra karar ver (Satışlar sayfasında bekler)</button></div>
    </AlertShell>
  );
}

export function DeleteResultAlert({ m, rest, ack }) {
  const ok = m.approved;
  const tone = ok ? ["border-emerald-500/60", "bg-emerald-500/15 border-emerald-500/40 text-emerald-400", "text-emerald-300"]
                  : ["border-red-500/60", "bg-red-500/15 border-red-500/40 text-red-400", "text-red-300"];
  return (
    <AlertShell tone={tone} icon={ok ? CheckCircle2 : XCircle} title={ok ? "Silme Talebiniz Onaylandı" : "Silme Talebiniz Reddedildi"}
                sub={ok ? `${m.decided_by} onayladı, satış silindi.` : `${m.decided_by} reddetti, satış yerinde duruyor.`} testId="delete-result-alert">
      <SaleLines sales={m.sales} />
      {rest > 0 && <p className="text-center text-xs text-slate-500">{rest} bildirim daha var</p>}
      <div><Button onClick={ack} className={`w-full py-5 text-white ${ok ? "bg-emerald-600 hover:bg-emerald-500" : "bg-red-600 hover:bg-red-500"}`} data-testid="delete-result-ok">Tamam</Button></div>
    </AlertShell>
  );
}
